var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Warning from '@material-ui/icons/Warning';
import React from 'react';
import { LicenseSummaryDialog } from './SummaryDialog';
import { Alert } from './AlertBase';
var useStyles = makeStyles(function (theme) { return ({
    root: {
        backgroundColor: '#DE3131',
        border: 'thin solid #FF9563',
        color: 'white'
    },
    button: {
        backgroundColor: 'white',
        color: '#191919'
    }
}); });
export function LicenseAlert(_a) {
    var detailsState = _a.detailsState, licenseRequestState = _a.licenseRequestState, onLicensesRequest = _a.onLicensesRequest, alertProps = __rest(_a, ["detailsState", "licenseRequestState", "onLicensesRequest"]);
    var classes = useStyles();
    var _b = __read(React.useState(false), 2), summaryOpen = _b[0], setSummaryOpen = _b[1];
    var licenseInfo = detailsState.result;
    if (!licenseInfo)
        return null;
    var CTA = (React.createElement(Button, { className: classes.button, "data-testid": "lcui-review-summary-button", disableElevation: true, disableRipple: true, variant: "contained", onClick: function () { return setSummaryOpen(true); } }, "Request licenses"));
    var WarningIcon = React.createElement(Warning, { htmlColor: "#FFFFFF" });
    return (React.createElement(Alert, __assign({}, alertProps, { className: classes.root, icon: WarningIcon, callToAction: CTA }),
        React.createElement(LicenseSummaryDialog, { licenseInfo: licenseInfo, licenseRequestState: licenseRequestState, open: summaryOpen, onClose: function () { return setSummaryOpen(false); }, onLicensesRequestClick: onLicensesRequest }),
        React.createElement(Typography, { variant: "body1", gutterBottom: true, color: "inherit" }, "ACTION REQUIRED: Your product usage exceeds the number of purchased licenses. You must bring your account into compliance immediately. Please request and purchase the required licenses."),
        React.createElement(Typography, { variant: "body2", color: "inherit" },
            "Additional licenses required: ",
            licenseInfo.unlicensedUsers.toLocaleString())));
}
//# sourceMappingURL=LicenseAlert.js.map